export const textareaMaxlength = 1000 ;
export const textareaRows = 15 ;